import { render, staticRenderFns } from "./FinetuneSuggestionDetail.vue?vue&type=template&id=592eddd2&scoped=true&"
import script from "./FinetuneSuggestionDetail.vue?vue&type=script&lang=js&"
export * from "./FinetuneSuggestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./FinetuneSuggestionDetail.vue?vue&type=style&index=0&id=592eddd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592eddd2",
  null
  
)

export default component.exports